import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Table from "../../../../../../../../common/components/table-manager/v1.1/table";
import PageLoader from "../../../../../../../../components/PageLoader";
import { useAppDispatch } from "../../../../../../../../hooks/hooks";
import { orgRegistries } from "../../../../../../../../redux/org-registries/action";
import { useSelector } from "react-redux";
import { selectOrgRegistriesListItems } from "../../../../../../../../redux/org-registries/selector";
import { selectListItems } from "../../../../../../../../redux/library/selector";

const DBNBizTickets = ({ orgRegistry }: any) => {
  const dispatch = useAppDispatch();
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10);
  const orgRegistryTicketItems = useSelector(selectOrgRegistriesListItems)
  const libraryData = useSelector(selectListItems)
  const [columnDefs, setColumnDefs] = useState({});

  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'Message.TicketPId', headerName: 'Ticket PId', sortable: true, filter: true, filterType: 'text' },
      {
        field: 'Message.TicketPriorityId',
        headerName: 'Ticket Priority',
        cellRenderer: 'libraryRendererComponent',
        cellRendererParams: { library: libraryData?.result?.TicketPriority },
        sortable: true,
        filter: true,
        filterType: 'text',
        filterBy: libraryData?.result?.TicketPriority,
        align: 'text-center'
      },
      {
        field: 'Message.TicketStatusId',
        headerName: 'Ticket Priority',
        cellRenderer: 'libraryRendererComponent',
        cellRendererParams: { library: libraryData?.result?.TicketStatus },
        sortable: true,
        filter: true,
        filterType: 'text',
        filterBy: libraryData?.result?.TicketStatus,
        align: 'text-center'
      },
      { field: 'Message.OpenNetworkIssueGuid', headerName: 'Open Network Issue Guid', sortable: true, filter: true, filterType: 'text' },
      { field: 'Message.IsOpenNetworkIssue', headerName: 'Open Network Issue', cellRenderer: 'yesNoRenderer' },
      { field: 'Message.IsResolved', headerName: 'Resolved', cellRenderer: 'yesNoRenderer' },
      { field: 'Message.Category', headerName: 'Category', sortable: true, filter: true, filterType: 'text' },
      { field: 'Message.OwnerType', headerName: 'Owner Type', sortable: true, filter: true, filterType: 'text' },
      { field: 'Message.RequestorName', headerName: 'Requestor Name', sortable: true, filter: true, filterType: 'text' },
      { field: 'Message.RequestorPhoneNo', headerName: 'Requestor PhoneNo', sortable: true, filter: true, filterType: 'text' },
      { field: 'Message.Sub_Category', headerName: 'Sub Category', sortable: true, filter: true, filterType: 'text' },
      { field: 'Message.Subject', headerName: 'Subject', sortable: true, filter: true, filterType: 'text' },
      { field: 'Message.DueDateOnUtc', headerName: 'Due Date On', isDateValueFormat: true, },
      { field: 'Message.CreatedOnUtc', headerName: 'Created On', isDateValueFormat: true, },
      { field: 'Message.ModifiedOnUtc', headerName: 'Modified On', isDateValueFormat: true, }
    ]);
  }

  const fetchDBNBizTicketsList = async () => {
    await dispatch(orgRegistries.resetAction({ actionType: 'list' }))
    await dispatch(orgRegistries.list({
      url: `https://igm.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/service/cma/management/tickets/list`,
      entity: 'orgRegistries',
      jsonData:
      {
        PageNumber: pageData,
        PageSize: pageSize,
        SortField: "Id",
        SortOrder: "desc",
      }
    }))
  }

  const additionButtons: any = [
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload this table</title>
          <path d="M21 3V8M21 8H16M21 8L18 5.29168C16.4077 3.86656 14.3051 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.2832 21 19.8675 18.008 20.777 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
      callback: () => handleReloadData(),
    },
  ];

  const handleReloadData = () => {
    fetchDBNBizTicketsList();
  };

  const handleSearch = async (data: any) => {
    let searchCriteria = {};
    if (data?.column) {
      searchCriteria = [{
        FieldName: data?.column || data?.searchCriteriaList,
        FieldText: data?.column || data?.searchCriteriaList,
        FieldType: 'text',
        FilterOperatorId: data?.filterOperatorId || 6,
        FieldValue: data?.value
      }]
    } else {
      searchCriteria = [{
        FieldName: "Name",
        FieldText: "Name",
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    }
    await dispatch(orgRegistries.resetAction({ actionType: 'list' }))
    await dispatch(orgRegistries.list({
      url: `https://igm.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/service/cma/management/tickets/list`,
      entity: 'orgRegistries',
      jsonData:
      {
        PageNumber: pageData,
        PageSize: pageSize,
        SortField: "Id",
        SortOrder: "desc",
        Searches: searchCriteria,
      }
    }));
  }

  useEffect(() => {
    createColumnDefs();
    fetchDBNBizTicketsList();
  }, [pageData, pageSize])

  return (
    <>
      {orgRegistryTicketItems?.isLoading ? <PageLoader /> :
        <Table
          columnData={columnDefs}
          rowData={orgRegistryTicketItems?.result?.items}
          setPageData={setPageData} setPageSize={setPageSize}
          paginationData={orgRegistryTicketItems?.result?.pagination}
          enableFilter={true} onSearch={handleSearch}
          checkboxConfig={{
            allowMultiSelect: true,
            defaultSelectedIds: [],
            isDisabled: false,
            keyColumn: 'Id',
          }}
          additionButtons={additionButtons}
          headingName="DBNBiz Tickets"
        />
      }
    </>
  );
};

export default DBNBizTickets;


